import React from 'react';
import { Grid } from '@mui/material';
import {
  ActivityAssignmentData,
  StepWithResponseData,
} from 'hooks/activities/useQueryActivityAssignments';
import ActivityAssignmentStep from 'pages/Activities/ActivityAssignmentStep/ActivityAssignmentStep';

interface AssignmentStepsProps {
  activityAssignment: ActivityAssignmentData;
  steps: StepWithResponseData[];
  hideComplete?: boolean;
}

type Props = AssignmentStepsProps;

const AssignmentSteps = ({ activityAssignment, steps, hideComplete }: Props) => {
  if (!steps?.length) {
    return null;
  }
  const stepCount = steps.length;

  return (
    <Grid container>
      {steps.map((stepWithResponse, i) => (
        <ActivityAssignmentStep
          key={stepWithResponse.id}
          activityAssignment={activityAssignment}
          stepWithResponse={stepWithResponse}
          stepNumber={i + 1}
          totalSteps={stepCount}
          hideComplete={hideComplete}
        />
      ))}
    </Grid>
  );
};

export default AssignmentSteps;
